export const EMOJI_PICKER_BATCH_SIZE = 64;

export const EMOJI_PICKER_LOAD_MORE_SCROLL_OFFSET_PX = 48;

export const EMOJI_PICKER_LOAD_MORE_KEY = "PageDown";
